import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"

const billsAndPaymentsRootPath = RoutePath.create(
    `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/factures-et-paiements`
)

export const billsAndPaymentsRoutesPaths = {
    billsAndPayments: billsAndPaymentsRootPath,
    billsAndPaymentsAgreement: billsAndPaymentsRootPath.create(`/:agreementId`),
    paymentsDetails: billsAndPaymentsRootPath.create(`/:agreementId/mes-informations-de-paiement`),
    bankingPaymentDetails: billsAndPaymentsRootPath.create(
        `/:agreementId/mes-informations-de-paiement/paiement`
    ),
    billingPaymentDetails: billsAndPaymentsRootPath.create(
        `/:agreementId/mes-informations-de-paiement/adresse-facturation`
    ),
    paymentAdequacy: billsAndPaymentsRootPath.create(`/:agreementId/ajuster-mon-paiement-mensuel`),
    paymentAdequacySuccess: billsAndPaymentsRootPath.create(
        `/:agreementId/ajuster-mon-paiement-mensuel/succes?paymentDay=:paymentDay&paymentCollectionStatus=:paymentCollectionStatus`
    ),
} as const satisfies RoutePaths
